export default {
      id: "icon-ring-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-ring",
      toString: function () {
        return this.url;
      }
    }